import { ComponentProps, FC } from 'react';

import { cn } from '@/lib/utils';

interface ModalTitleProps extends ComponentProps<'div'> {}

export const ModalTitle: FC<ModalTitleProps> = ({ children, className, ...props }) => {
  return (
    <div {...props} className={cn('text-lg font-semibold mb-4', className)}>
      {children}
    </div>
  );
};
